import { useUserRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetUserCommonInfoQuery } from "../../features/identity/identityApi";

export { useUserRoutes };

export default GetDefaultIndex({ title: "کاربران", query: useGetUserCommonInfoQuery });
